"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderBy = void 0;
const order_by_1 = require("../order-by");
exports.orderBy = (values, iteratees, orders) => order_by_1.orderBy([...values], iteratees, orders);
//# sourceMappingURL=order-by.js.map